import EventEmitter from "events";

export default class BaseLid extends EventEmitter {
    start(detectionLangs) {
        throw new Error('未實現start()');
    }

    stop() {
        throw new Error('未實現stop()');
    }
}
